import DashboardTeacher from "components/module/dashboardTeacher"

const DashboardTeacherPage = () => {
  return <DashboardTeacher />
}

export default DashboardTeacherPage
